"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "saronno": {
    "c1d95880": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "aquilone": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9919d87f": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-ferrara": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "273d6963": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-berretta": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d182cf69": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-colombara-e-cassina-ferrara": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc3609c0": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-italia": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f11abff0": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-roba-paolo": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "585dadd4": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04704749": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "la-cascinetta": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84686cff": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "matteotti": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a25e6782": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "posta-nuova": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9fd823fd": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "prealpi": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dedd03f6": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "skipSearch": false
    }],
    "santuario": [{
      "hkey": "cb9c17a1",
      "slug": "saronno",
      "name": "Saronno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;